"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "array", {
  enumerable: true,
  get: function get() {
    return _array.array;
  }
});
Object.defineProperty(exports, "boolean", {
  enumerable: true,
  get: function get() {
    return _boolean["boolean"];
  }
});
Object.defineProperty(exports, "compose", {
  enumerable: true,
  get: function get() {
    return _utils.compose;
  }
});
Object.defineProperty(exports, "constant", {
  enumerable: true,
  get: function get() {
    return _constants.constant;
  }
});
Object.defineProperty(exports, "date", {
  enumerable: true,
  get: function get() {
    return _date.date;
  }
});
Object.defineProperty(exports, "describe", {
  enumerable: true,
  get: function get() {
    return _describe.describe;
  }
});
Object.defineProperty(exports, "dict", {
  enumerable: true,
  get: function get() {
    return _mapping.dict;
  }
});
Object.defineProperty(exports, "dispatch", {
  enumerable: true,
  get: function get() {
    return _dispatch.dispatch;
  }
});
Object.defineProperty(exports, "either", {
  enumerable: true,
  get: function get() {
    return _either.either;
  }
});
Object.defineProperty(exports, "either3", {
  enumerable: true,
  get: function get() {
    return _either.either3;
  }
});
Object.defineProperty(exports, "either4", {
  enumerable: true,
  get: function get() {
    return _either.either4;
  }
});
Object.defineProperty(exports, "either5", {
  enumerable: true,
  get: function get() {
    return _either.either5;
  }
});
Object.defineProperty(exports, "either6", {
  enumerable: true,
  get: function get() {
    return _either.either6;
  }
});
Object.defineProperty(exports, "either7", {
  enumerable: true,
  get: function get() {
    return _either.either7;
  }
});
Object.defineProperty(exports, "either8", {
  enumerable: true,
  get: function get() {
    return _either.either8;
  }
});
Object.defineProperty(exports, "either9", {
  enumerable: true,
  get: function get() {
    return _either.either9;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _string.email;
  }
});
Object.defineProperty(exports, "exact", {
  enumerable: true,
  get: function get() {
    return _object.exact;
  }
});
Object.defineProperty(exports, "fail", {
  enumerable: true,
  get: function get() {
    return _fail.fail;
  }
});
Object.defineProperty(exports, "guard", {
  enumerable: true,
  get: function get() {
    return _guard.guard;
  }
});
Object.defineProperty(exports, "hardcoded", {
  enumerable: true,
  get: function get() {
    return _constants.hardcoded;
  }
});
Object.defineProperty(exports, "inexact", {
  enumerable: true,
  get: function get() {
    return _object.inexact;
  }
});
Object.defineProperty(exports, "instanceOf", {
  enumerable: true,
  get: function get() {
    return _instanceOf.instanceOf;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _number.integer;
  }
});
Object.defineProperty(exports, "iso8601", {
  enumerable: true,
  get: function get() {
    return _date.iso8601;
  }
});
Object.defineProperty(exports, "json", {
  enumerable: true,
  get: function get() {
    return _json.json;
  }
});
Object.defineProperty(exports, "jsonArray", {
  enumerable: true,
  get: function get() {
    return _json.jsonArray;
  }
});
Object.defineProperty(exports, "jsonObject", {
  enumerable: true,
  get: function get() {
    return _json.jsonObject;
  }
});
Object.defineProperty(exports, "lazy", {
  enumerable: true,
  get: function get() {
    return _lazy.lazy;
  }
});
Object.defineProperty(exports, "map", {
  enumerable: true,
  get: function get() {
    return _utils.map;
  }
});
Object.defineProperty(exports, "mapping", {
  enumerable: true,
  get: function get() {
    return _mapping.mapping;
  }
});
Object.defineProperty(exports, "maybe", {
  enumerable: true,
  get: function get() {
    return _optional.maybe;
  }
});
Object.defineProperty(exports, "mixed", {
  enumerable: true,
  get: function get() {
    return _constants.mixed;
  }
});
Object.defineProperty(exports, "nonEmptyArray", {
  enumerable: true,
  get: function get() {
    return _array.nonEmptyArray;
  }
});
Object.defineProperty(exports, "nonEmptyString", {
  enumerable: true,
  get: function get() {
    return _string.nonEmptyString;
  }
});
Object.defineProperty(exports, "null_", {
  enumerable: true,
  get: function get() {
    return _constants.null_;
  }
});
Object.defineProperty(exports, "nullable", {
  enumerable: true,
  get: function get() {
    return _optional.nullable;
  }
});
Object.defineProperty(exports, "number", {
  enumerable: true,
  get: function get() {
    return _number.number;
  }
});
Object.defineProperty(exports, "numericBoolean", {
  enumerable: true,
  get: function get() {
    return _boolean.numericBoolean;
  }
});
Object.defineProperty(exports, "object", {
  enumerable: true,
  get: function get() {
    return _object.object;
  }
});
Object.defineProperty(exports, "oneOf", {
  enumerable: true,
  get: function get() {
    return _either.oneOf;
  }
});
Object.defineProperty(exports, "optional", {
  enumerable: true,
  get: function get() {
    return _optional.optional;
  }
});
Object.defineProperty(exports, "poja", {
  enumerable: true,
  get: function get() {
    return _array.poja;
  }
});
Object.defineProperty(exports, "pojo", {
  enumerable: true,
  get: function get() {
    return _object.pojo;
  }
});
Object.defineProperty(exports, "positiveInteger", {
  enumerable: true,
  get: function get() {
    return _number.positiveInteger;
  }
});
Object.defineProperty(exports, "positiveNumber", {
  enumerable: true,
  get: function get() {
    return _number.positiveNumber;
  }
});
Object.defineProperty(exports, "predicate", {
  enumerable: true,
  get: function get() {
    return _utils.predicate;
  }
});
Object.defineProperty(exports, "regex", {
  enumerable: true,
  get: function get() {
    return _string.regex;
  }
});
Object.defineProperty(exports, "string", {
  enumerable: true,
  get: function get() {
    return _string.string;
  }
});
Object.defineProperty(exports, "truthy", {
  enumerable: true,
  get: function get() {
    return _boolean.truthy;
  }
});
Object.defineProperty(exports, "tuple1", {
  enumerable: true,
  get: function get() {
    return _tuple.tuple1;
  }
});
Object.defineProperty(exports, "tuple2", {
  enumerable: true,
  get: function get() {
    return _tuple.tuple2;
  }
});
Object.defineProperty(exports, "tuple3", {
  enumerable: true,
  get: function get() {
    return _tuple.tuple3;
  }
});
Object.defineProperty(exports, "tuple4", {
  enumerable: true,
  get: function get() {
    return _tuple.tuple4;
  }
});
Object.defineProperty(exports, "tuple5", {
  enumerable: true,
  get: function get() {
    return _tuple.tuple5;
  }
});
Object.defineProperty(exports, "tuple6", {
  enumerable: true,
  get: function get() {
    return _tuple.tuple6;
  }
});
Object.defineProperty(exports, "undefined_", {
  enumerable: true,
  get: function get() {
    return _constants.undefined_;
  }
});
Object.defineProperty(exports, "unknown", {
  enumerable: true,
  get: function get() {
    return _constants.unknown;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _string.url;
  }
});

var _guard = require("./guard");

var _utils = require("./utils");

var _array = require("./array");

var _boolean = require("./boolean");

var _constants = require("./constants");

var _date = require("./date");

var _describe = require("./describe");

var _dispatch = require("./dispatch");

var _either = require("./either");

var _fail = require("./fail");

var _instanceOf = require("./instanceOf");

var _json = require("./json");

var _lazy = require("./lazy");

var _mapping = require("./mapping");

var _number = require("./number");

var _object = require("./object");

var _optional = require("./optional");

var _string = require("./string");

var _tuple = require("./tuple");